export default __webpack_public_path__ + "static/media/artefact_logo.b0e0d402.png";